import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import Button from "./Button";

export function HeroSection({ onShopNowClick }) {
  return (
    <Section
      bgColor="default"
      size="large"
      bgImage=""
      bgImageOpacity={1}
    >
      <div className="container mx-auto text-center">
        <SectionHeader
          title="FurniSnapp Marketplace"
          subtitle="Discover unique furniture pieces from sellers in your area"
          size={1}
          spaced={true}
        />
        <Button
          variant="primary"
          size="lg"
          onClick={onShopNowClick}
        >
          Shop Now
        </Button>
      </div>
    </Section>
  );
}

export function QuoteSection() {
  return (
    <Section
      bgColor="light"
      size="medium"
    >
      <div className="container mx-auto text-center">
        <blockquote className="text-2xl italic text-gray-700">
          "Transform your space with unique, pre-loved furniture that tells a story"
        </blockquote>
      </div>
    </Section>
  );
}

export function GallerySection() {
  return (
    <Section
      bgColor="default"
      size="medium"
    >
      <div className="container mx-auto">
        <SectionHeader
          title="Featured Listings"
          subtitle="Browse our curated selection of furniture"
          size={2}
          spaced={true}
          className="text-center"
        />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
          {/* Gallery items will be populated by MarketplaceItems component */}
        </div>
      </div>
    </Section>
  );
}

export function DesignerSection() {
  return (
    <Section
      bgColor="light"
      size="medium"
    >
      <div className="container mx-auto">
        <SectionHeader
          title="For Designers & Sellers"
          subtitle="List your furniture pieces and reach buyers in your area"
          size={2}
          spaced={true}
          className="text-center"
        />
        <div className="flex justify-center mt-6">
          <Button
            variant="secondary"
            size="lg"
          >
            Start Selling
          </Button>
        </div>
      </div>
    </Section>
  );
}

export function TestimonialsSection() {
  const testimonials = [
    {
      name: "Sarah M.",
      text: "Found the perfect vintage dresser for my bedroom. The marketplace made it so easy!",
    },
    {
      name: "John D.",
      text: "Sold my old couch within a week. Great platform for furniture lovers.",
    },
    {
      name: "Emily R.",
      text: "Love the quality of furniture I've found here. Much better than buying new!",
    },
  ];

  return (
    <Section
      bgColor="default"
      size="medium"
    >
      <div className="container mx-auto">
        <SectionHeader
          title="What Our Users Say"
          subtitle="Join thousands of satisfied buyers and sellers"
          size={2}
          spaced={true}
          className="text-center"
        />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
              <p className="text-gray-700 mb-4">"{testimonial.text}"</p>
              <p className="font-semibold text-gray-900">{testimonial.name}</p>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}
